// code: negative number
export const getErrorMsg = (code = '') => {
  const strCode = code.toString()
  const defaultError = 'register.LAB_HISTORY_SHARE_ERROR'
  const msg = {
    '-3': 'register.LAB_ACCOUNT_EMAIL_FORM_WRONG',
    '-5': 'register.LAB_CLUB_INVITE_CODE_ERROR',
    '-7': 'register.LAB_VERIFICATION_CODE_ERROR',
    '-12': 'register.LAB_REGISTER_MUCH', // 一天內註冊超過50次並須成功註冊（相同ip 條件）
    '-14': 'register.LAB_KYC_INVALID_EMAIL', // username email 後綴是有被ban 的 ex. xxxx@123.com
    '-1': 'register.LAB_ACCOUNT_ALREADY_REGISTERED',  // -16 not work
    '-16': 'register.LAB_ACCOUNT_ALREADY_REGISTERED',
  }[strCode]

  return msg || defaultError
}


export const getUspData = (locale, globalConfig, isMobile) => {
  if (isMobile) {
    return [
      {
        url: '/static/img/home/global.png',
        title: 'register.LAB_TITLE_2',
        context: 'register.LAB_CONTENT_2'
      },
      {
        url: '/static/img/home/game.png?v=20230224',
        title: 'register.LAB_TITLE_3',
        context: 'register.LAB_CONTENT_3',
        link: globalConfig.uspLink.promotion
      },
      {
        url: '/static/img/home/money.png?v=20230224',
        title: 'register.LAB_TITLE_1',
        context: 'register.LAB_CONTENT_1',
        link: globalConfig.uspLink.instantRakeback
      },
      {
        url: '/static/img/home/protect.png',
        title: 'register.LAB_TITLE_4',
        context: globalConfig.protectPhoto
      }
    ]
  } else {
      return [
        {
          url: '/static/img/home/pc/global.png',
          title: 'register.LAB_TITLE_2',
          context: 'register.LAB_CONTENT_2'
        },
        {
          url: '/static/img/home/pc/game.png?v=20230224',
          title: 'register.LAB_TITLE_3',
          context: 'register.LAB_CONTENT_3',
          link: globalConfig.uspLink.promotion
        },
        {
          url: '/static/img/home/pc/money.png?v=20230224',
          title: 'register.LAB_TITLE_1',
          context: 'register.LAB_CONTENT_1',
          link: globalConfig.uspLink.instantRakeback
        },
        {
          url: '/static/img/home/pc/protect.png',
          title: 'register.LAB_TITLE_4',
          context: 'register.LAB_CONTENT_4'
        }
      ]
    }
}
